import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';

const RequirementList = ({ title, items, required_active_conditions }) => {
  return (
    <div>
      <h4 className="font-semibold text-blue-800 mb-3">{title}</h4>
      <ul className="space-y-2">
        {items.map((item, index) => (
          <li key={index} className="flex items-start gap-2">
            <span className="text-gray-700">- {item.label}</span>
            {required_active_conditions &&
            required_active_conditions.includes(item.condition) ? (
              <CloseCircleOutlined className="text-red-500 text-xl flex-shrink-0 mt-0.5" />
            ) : (
              <CheckCircleOutlined className="text-green-500 text-xl flex-shrink-0 mt-0.5" />
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default RequirementList;
